import { Button, message, Radio, Statistic, Table } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { TransactionList } from '../../../apis/Admin/Financials/TransactionList';
import { TxnStatusChange } from '../../../apis/Admin/Financials/TxnStatusChange';
import { useGlobalState } from '../../../store/state';
import CurrencyIcon from '../../Common/CurrencyIcon';
import { IoIosCheckmarkCircle, IoIosCloseCircleOutline } from 'react-icons/io';
// import './HomeTabledComponents.styles.scss'

const FinanceWithdrawComponent = ({ withdrawType }) => {
  const [user] = useGlobalState('user');
  const [withdrawls, setWithdrawls]= useState({
    paging: {
      page: 1,
      limit: 10,
      total: 0,
    },
    mode: withdrawType || 'influencers',
    type: 'withdraw',
    data: [],
  });

  const getTranscations = (mode, type, page, limit) =>{
    const _data = {
      mode,
      type,
      page,
      limit,
    };
    TransactionList(user.accessToken, _data).then(({ status, response })=>{
      console.log('transaction response', response);
      if (status === 200) {
        // message.success("widthdrawls listy sready")
        setWithdrawls({
          ...withdrawls,

          data: response.transactions.map((txn) =>{
            return {
              key: txn._id,
              walletId: txn.walletId,
              name: (txn.firstname || 'n/a')+ ' ' + (txn.lastname || ''),
              amount: txn.amount,
              createdAt: txn.createdAt,
              bankname: txn.bankname || 'n/a',
              accountnumber: txn.accountnumber || 'n/a',
              ifsc: txn.ifsc || 'n/a',
            };
          }),
          paging: {
            ...withdrawls.paging,
            page: response.page,
            total: response.totalDocs,
          },
        });
      }
    });
  };


  useEffect(()=>{
    const { mode, type, paging: { page, limit } } = withdrawls;
    getTranscations(mode, type, page, limit);
  }, []);

  const columns = [
    {
      width: 200,
      title: 'User Information',
      dataIndex: 'name',
      key: 'name',
      render: (value, rest) => (
        <div className="table_name_field">{value}<span>{rest.walletId}</span></div>
      ),
    },
    {
      width: 160,
      title: 'Amount Requested',
      dataIndex: 'amount',
      key: 'amount',
      sorter: (a, b) => a.amount - b.amount,
      render: (value) =>(
        <>{CurrencyIcon()}<Statistic value={value}
          className="custom_number_format"/></>
      ),
    },
    {
      // width:160,
      title: 'Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      // sorter: (a, b) => a.amount - b.amount,
      render: (value) =>(
        <div>{moment(value).format('Do MMM YYYY hh:mm a')}</div>
      ),
    },
    {
      // width:160,
      title: 'Bank Name',
      dataIndex: 'bankname',
      key: 'bankname',
      // sorter: (a, b) => a.amount - b.amount,
      // render:(value) =>(
      //   <div>{moment(value).format('Do MMM YYYY hh:mm')}</div>
      // )
    },
    {
      // width:160,
      title: 'A/C Name & Number',
      dataIndex: 'accountnumber',
      key: 'accountnumber',
      // sorter: (a, b) => a.amount - b.amount,
      // render:(value) =>(
      //   <div>{moment(value).format('Do MMM YYYY hh:mm')}</div>
      // )
    },
    {
      // width:160,
      title: 'IFSC Code',
      dataIndex: 'ifsc',
      key: 'ifsc',
      // sorter: (a, b) => a.amount - b.amount,
      // render:(value) =>(
      //   <div>{moment(value).format('Do MMM YYYY hh:mm')}</div>
      // )
    },
    {
      width: 100,
      align: 'center',
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (value, rest) =>(
        <div>
          <a href="#"
            className="d-inline-block px-1 cursor-pointer"
            onClick={() => updateTxnStatus(rest.key, 'success')}
            title="Approve Request">
            <IoIosCheckmarkCircle size={26}
              color='#8d2fc0'/>
          </a>
          <a href="#"
            className="d-inline-block px-1 cursor-pointer"
            onClick={() => updateTxnStatus(rest.key, 'failed')}
            title="Reject Request">
            <IoIosCloseCircleOutline size={26}
              color='red'/>
          </a>
        </div>
      ),
    },
  ];

  // approve txn
  const updateTxnStatus = (id, status) =>{
    TxnStatusChange(user.accessToken, withdrawType, id, { status }).then(({ status, response })=>{
      console.log('rtxnb status response', response);
      if (status === 200) {
        message.success('Transaction Status Updated Successfully');
        const { mode, type, paging: { page, limit } } = withdrawls;
        getTranscations(mode, type, page, limit);
      } else {
        message.error('There some issue while updating status');
      }
    });
  };

  // @note: page changing if more than
  const changePage = (page) =>{
    const { mode, type, paging } = withdrawls;
    getTranscations(mode, type, page, paging.limit);
  };

  return (
    <div>
      <div className="common_card admin_stats_tabled p-3 h-100">
        <div className="admin_stats_tabled_data pt-2">
          <Table className="tiny_table"
            dataSource={withdrawls.data || []}
            columns={columns}
            pagination={{
              current: withdrawls.paging.page,
              total: withdrawls.paging.total,
              showSizeChanger: false,
              showQuickJumper: true,
              onChange: (v) => changePage(v),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default FinanceWithdrawComponent;
